import { Fact } from "../../ui/Fact";
import { statusLabel } from "../tov/guidelineCoverage";
import { DrawerSection, DrawerShell } from "./DrawerShell";
import type { EvidenceSelection } from "./useBrandGuidelines";
export function EvidenceDrawer(props: {
  selection: EvidenceSelection;
  websiteId: string;
  onClose: () => void;
}) {
  const link = () => props.selection.link;
  return (
    <DrawerShell
      kicker="Evidence quick look"
      title={props.selection.item.title}
      ariaLabel={`Evidence quick look: ${props.selection.item.title}`}
      closeLabel="Close evidence quick look"
      asideClass="signal-evidence-drawer"
      onClose={props.onClose}
      footer={
        <a class="scan-btn scan-btn-primary" href={`/w/${props.websiteId}/tov`}>
          Open in guideline workspace
        </a>
      }
    >
      <DrawerSection title="Guidance">
        <p>{props.selection.item.description}</p>
        <div class="signal-tag-row">
          <span>{props.selection.item.type}</span>
          <span>{props.selection.item.category}</span>
          <span>{props.selection.item.sourceTrust.label}</span>
        </div>
      </DrawerSection>
      <DrawerSection title="Source">
        <dl class="signal-drawer-facts">
          <Fact
            label="Document"
            value={props.selection.source?.title ?? "Source not established"}
          />
          <Fact label="Locator" value={link().evidence.locator} />
          <Fact label="Relationship" value={link().relationship} />
          <Fact
            label="Confidence"
            value={
              link().confidence === null ? "Not scored" : `${link().confidence}`
            }
          />
        </dl>
      </DrawerSection>
      <DrawerSection title="Evidence">
        <p>{link().evidence.claim}</p>
      </DrawerSection>
      <DrawerSection title="Version">
        <p>
          {props.selection.profile.name} / {props.selection.version.label} /{" "}
          {statusLabel(props.selection.version.status)}
        </p>
      </DrawerSection>
    </DrawerShell>
  );
}
